module.exports = __webpack_public_path__ + "img/hxkj-jjfa-5.1b13abce.svg";